module.exports = __webpack_public_path__ + "img/boho_rio_gift_drum.f1ade980.svg";